import React from 'react';
import Lottie from 'react-lottie';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { animationRandomizerThreshold } from '@flow/store/animation/constants';

const Animation = styled.div`
  position: absolute;
  top: 0;
  left: 0;
 
  svg {
    path {
      fill: ${props => props.color || props.theme.highlightColor};
    }
  }
`;

const AnimationWrapper = styled.span`
  position: relative;
  display: inline-block;
  width: 1.3em;
  height: 1px;
  vertical-align: top;
  text-align: left;
  
  &.animation-splash {
    ${Animation} {
      top: 9px;  
      left: -4px;
    }
  }
  
  &.animation-heptagon {
    ${Animation} {
      top: 8px;  
      //left: -5px;
    }
  }
  
  &.animation-ellipses {
    ${Animation} {
      top: 9px;  
    }
  }
  
  &.animation-ellipsesHaitari {
    ${Animation} {
      top: 8px;  
    }
  }
  
  &.animation-checkerboard {
    ${Animation} {
      top: 8px;  
    }
  }
  
  &.animation-pointy {
    ${Animation} {
      top: 8px;  
    }
  }
  
  &.animation-star {
    ${Animation} {
      top: 3px;  
    }
  }
  
  &.animation-ring {
    ${Animation} {
      top: 2px;  
      //left: -2px
    }
  }
`;

interface Props {
  shape: any;
  type: string;
  width?: number|string;
  height?: number|string;
  color?: string;
  isActive?: boolean;
  animationIndex: number | undefined;
  autoPlay?: boolean;
}

interface State {
  isAnimating: boolean;
}

export class DingbatAnimation extends React.Component<Props, State> {
  private animation: any;
  private readonly magicIndex: number | undefined;
  private isAnimating: boolean;

  constructor(props: Props) {
    super(props);
    if (props.autoPlay) {
      this.magicIndex = undefined;
    } else {
      this.magicIndex = Math.floor(Math.random() * animationRandomizerThreshold);
    }
    this.isAnimating = false;
  }

  private _animationComplete = () => {
    this.isAnimating = false;
  };

  componentWillReceiveProps(nextProps: Props) {

    if (nextProps.autoPlay) {
      this.animation.anim.play();
      this.isAnimating = true;
      return;
    }

    if(!nextProps.isActive) {
      this.animation.anim.stop();
      return;
    }

    if (!this.isAnimating && nextProps.animationIndex === this.magicIndex) {
      this.animation.anim.play();
      this.isAnimating = true;
    } else if (!this.isAnimating) {
      this.animation.anim.stop();
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      shape,
      type,
      width,
      height,
      color,
      autoPlay = false,
    } = this.props;

    const defaultOptions = {
      loop: autoPlay,
      autoPlay: autoPlay,
      animationData: shape,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    const animationComplete = this._animationComplete;

    return (
      <AnimationWrapper className={'animation-' + type} style={{ width: `${width}px`, height: `${height}px` }}>
        <Animation color={color}>
          <Lottie
            namespace={'animation-' + type}
            ref={(animation: any) => {
              if (animation) {
                this.animation = animation;
                this.animation.anim.addEventListener('complete', animationComplete);
              }
            }}
            options={defaultOptions}
            width={width}
            height={height}
          />
        </Animation>
      </AnimationWrapper>
    );
  }
};

export default connect((state: any) => ({
  animationIndex: state.animationReducer.animationIndex,
}), {})(DingbatAnimation);


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/animation/DingbatAnimation.tsx